import { ReactElement, useCallback, useEffect, useMemo, useState } from 'react';

import {
  NOTIFICATION_TOUR_ANCHORS,
  NotificationsPopover,
  useNotificationCounts,
} from '../notifications/index.js';

import { QuickUserToggler } from '_metronic/layout/components/extras/QuickUserToggler';

export type UserMenuWithNotificationsProps = {
  withNotifications: boolean;
};

export function UserMenuWithNotifications({
  withNotifications,
}: UserMenuWithNotificationsProps): ReactElement {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const { counts, markAllAsRead, markAsRead } = useNotificationCounts({
    enabled: withNotifications,
  });

  const handleClose = useCallback(() => setAnchorEl(null), []);

  useEffect(() => {
    if (!withNotifications) setAnchorEl(null);
  }, [withNotifications]);

  const notifications = useMemo(
    () => ({ unread: counts.unread, onOpen: setAnchorEl }),
    [counts.unread]
  );

  return (
    <>
      <QuickUserToggler
        notifications={withNotifications ? notifications : undefined}
        tourAnchorId={withNotifications ? NOTIFICATION_TOUR_ANCHORS.avatar : undefined}
      />
      {withNotifications && (
        <NotificationsPopover
          anchorEl={anchorEl}
          counts={counts}
          markAllAsRead={markAllAsRead}
          markAsRead={markAsRead}
          onClose={handleClose}
        />
      )}
    </>
  );
}
